import FunifierWidget from "@/components/funifier/widget";
import Title from "@/components/ui/title";
import { InfoCircledIcon } from "@radix-ui/react-icons";

export default function Ranking() {
  return (
    <div>
      <Title>Ranking</Title>
      <div className="flex flex-col gap-4 md:flex-row md:items-center">
        <div className="flex-1">
          <div className="prose mx-auto">
            <InfoCircledIcon className="w-16 h-16" />
            <p>
              Esta página de exemplo utiliza o Widget <b>FWLeaderboard</b> e
              pode ser alterado diretamente do Funifier Studio.
            </p>
            <p>
              Porém através do consumo de nossa API, é possivel criar um
              leaderboard com visual totalmente customizado.
            </p>
          </div>
        </div>
        <div className="md:flex-1 md:p-10 max-w-screen-md h-[70vh]">
          <FunifierWidget id="FWLeaderboard" />
        </div>
      </div>
    </div>
  );
}
